import React from "react";

import img1 from "../img/of war and other obsolete games&&Sad toys of overdressed cavemen I---Interweaving of textured layers in Adobe Photoshop over curated, AI-generated visuals___2025-06[[3]].jpg";
export default function Machine_2_1() {
  return (
    <div className="panel-block">
      <div className="panel-container-left">
        <img
          loading="lazy"
          src={img1}
          alt="2.1 · ABOUT THE VAULT"
        />
      </div>

      <div className="panel-container-right">
        <h2>2.1 · What you'll find here</h2>

            <p>
          Visual works and experimental pieces
        </p>

        <p>
         Technomantic artifacts, including <i>Malleus Nebularum</i>
        </p>

        <p>
         Limited digital editions
        </p>

        <p>
          Every artifact exists<br />
          under a condition.
        </p>

        <p>
          Occasional releases tied to specific cycles
        </p>
        
      </div>
    </div>
  );
}
